<template>
  <main class="marketing-email-create-recipient">
    <app-form ref="appForm" @submit="onSubmit">
      <marketing-form-senders v-model="senders"
                              :channel-data="item"
                              channel-type="EMAIL" 
                              @change-timeFilterActive = "isCustomSegmentedListTimeFilterActive = $event"
                              @changed-external="hasExternalFileChanged = true"/>

      <div class="marketing-email-create-recipient-actions">
        <button class="btn btn-outline btn-extra-round"
                type="button"
                @click="saveDrafts">
            {{$t('message.marketingGenerics.message.saveDraft')}}
        </button>

        <button class="btn btn-primary btn-extra-round"
                type="submit">
            {{$t('message.generics.message.advance')}}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import MarketingFormSenders from "@components/modules/marketing/generic/form/senders/MarketingFormSenders";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    AppForm,
    MarketingFormSenders,
  },

  props: {},

  computed: {
    item() {
      return this.$store.state.marketing.email.create.item ?
      this.$store.state.marketing.email.create.item :
      this.itemInSessionStorage
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
    isSegmentedList() {
      return this.senders.sendType === "SIMPLE_SEGMENTED_LIST";
    },
    isExternalList() {
      return this.senders.sendType === "EXTERNAL";
    },
    isCustomSegmentedList() {
      return this.senders.sendType === "CUSTOM_SEGMENTED_LIST";
    },
  },

  watch: {},

  data() {
    return {
      senders: {
        sendType: undefined,
        configuration: undefined,
        sourceNote: undefined,
        file: undefined,
      },
      hasExternalFileChanged: false,
      isCustomSegmentedListTimeFilterActive: false
    };
  },

  methods: {
    setHasEdited() {
      this.hasEdited = true;
    },
    async saveDrafts() {
      try {
        const isValid = await this.validateRecipientType();
  
        if (isValid) {
          if(this.isExternalList && this.item.rawContent.includes("{PRIMEIRO_NOME}")) {
            return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Não é possível utilizar base externa com variáveis no corpo da mensagem",
                });   
          } 
          this.setRecipients();
          this.$router.push({
            path: "/marketing/email",
          });
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.draftSaved'),
          });
        }        
      } catch (error) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: error,
        });
      }
    },
    validateRecipientType() {
      if (
        this.isExternalList &&
        !this.senders.file &&
        !Array.isArray(this.senders.configuration)
      ) {
        throw this.$t('message.errorMessages.message.selectFile')
      }

      else if (
        this.isSegmentedList &&
        (!this.senders.configuration ||
          Array.isArray(this.senders.configuration))
      ) {
        throw this.$t('message.errorMessages.message.selectList') 
      }

      else if(this.isCustomSegmentedList && this.isCustomSegmentedListTimeFilterActive && (!this.senders.configuration || !this.senders.configuration.timeFilterType)) {
        throw this.$t('message.errorMessages.message.selectEntryCriteria')
      }

      else {
        return true
      }
    },
    async setRecipients() {
     
      try {
        this.validateRecipientType();        
  
        if (this.isExternalList && !this.hasExternalFileChanged) {
          return;
        }      

        this.checkValidationsForCustomSegmentedList();
        
        EventBus.$emit("SHOW_SPINNER");

        if(!this.senders.sendType) {
          return
        }
        
        const item = await this.$api.marketing.email.message.setSendType({
          emailId: this.item.id,
          type: this.senders.sendType,
          configurationSimplesSegmentedList: this.senders.configuration,
          sourceNote: this.senders.sourceNote,
          file: this.senders.file,
        });     

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftSaved'),
        });

        this.$store.commit("EMAIL_CREATE_SET_ITEM", item);
      } catch (error) {
        if(this.isExternalList) this.senders.file = undefined
        throw error.response.data.message
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async onSubmit() {
      try {
        const isValid = await this.validateRecipientType();
        if(isValid) {
          if(this.isExternalList && this.item.rawContent.includes("{PRIMEIRO_NOME}")) {
            return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Não é possível utilizar base externa com variáveis no corpo da mensagem",
                });   
          }         
          await this.setRecipients();
          this.advanceStep();
        }        
      } catch (error) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: error,
        });
      }
    },
    async advanceStep() {
      this.$store.commit("SET_EMAIL_CREATE_STEP", 4);
      sessionStorage.setItem("email_step", 4);

      this.$router.push({
        path: "/marketing/email/criar/verificacao",
      });
    },
    checkValidationsForCustomSegmentedList() {
     if (this.senders.configuration === undefined) {
        this.senders.configuration = {
          timeFilterType: undefined,
          gender:  null,
          startAge:  0,
          endAge: 100,
          timeFilter: {
              type:  "PERIOD",
              startPeriod:  new Date().toISOString().substring(0, 10),
              endPeriod:  new Date().toISOString().substring(0, 10),
              days:  undefined   
          }
        }
      }
    }
  },

  created() {
    EventBus.$on("external-has-not-changed", () => this.hasExternalFileChanged = false);
  },

  beforeDestroy() {
    EventBus.$off("external-has-not-changed", () => this.hasExternalFileChanged = false);
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-create-recipient {
  .marketing-email-create-recipient-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>

